function page (path) {
  return () => import(/* webpackChunkName: '' */ `@/pages/${path}`).then(m => m.default || m)
}

export default [
  { path: '/', redirect: 'dashboard' },
  { path: '/login', name: 'login', component: page('auth/login.vue') },
  { path: '/register', name: 'register', component: page('auth/register.vue') },
  { path: '/dashboard', name: 'dashboard', component: page('dashboard.vue') },
  { path: '/facturacion', name: 'facturacion', component: page('facturacion.vue') },
  { path: '/monitoreo', name: 'monitoreo', component: page('monitoreo.vue') },
  { path: '/monitoreo/:id', name: 'monitoreo.view', component: page('monitoreo.view.vue') },
  { path: '/internet', name: 'internet', component: page('internet.vue') },
  { path: '/internet/:id', name: 'internet.view', component: page('internet.view.vue') },
  { path: '/television', name: 'television', component: page('television.vue') },
  // { path: '/pagar', name: 'pagar', component: page('pagar.vue') },
  // { path: '/pagar-online', name: 'pagar-online', component: page('pagar-online.vue') },
  { path: '/settings/profile', name: 'user_profile', component: page('settings/profile.vue') },
  { path: '*', component: require('@/pages/errors/404.vue') }
]
